"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var css_1 = require("@emotion/css");
var react_2 = require("@emotion/react");
function StaggerAnimation(props) {
    var children = props.children, start = props.start, from = props.from, to = props.to, _a = props.duration, duration = _a === void 0 ? 1000 : _a, _b = props.delayTimeInterval, delayTimeInterval = _b === void 0 ? 100 : _b, _c = props.initialDelayTime, initialDelayTime = _c === void 0 ? 0 : _c;
    var keyframe = (0, react_1.useMemo)(function () {
        return (0, react_2.keyframes)({
            to: __assign({}, to)
        });
        // no changes for final 'to'
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null, react_1.default.Children.map(children, function (child, index) {
        return react_1.default.cloneElement(child, {
            // css() is applied before styled() in genesis which causes the animation not working
            // use inline style to override styled()
            style: __assign({}, from),
            className: (0, css_1.cx)(
            // eslint-disable-next-line
            child.props.className, (0, css_1.css)({
                animationDuration: duration + "ms",
                animationFillMode: 'forwards',
                animationDelay: initialDelayTime + index * delayTimeInterval + "ms",
                animationName: start ? keyframe : undefined,
            })),
        });
    })));
}
exports.default = StaggerAnimation;
